import React from 'react';
import { LineItem } from './line-item';

const BorderBottomLineItem = () => {
  return (
    <LineItem
      label={{ }}
      value={{ }}
      optionalValue={{ }}
      customClass="summary-line"
    />
  );
};

const BorderTopLineItem = () => {
  return (
    <LineItem
      label={{ }}
      value={{ }}
      optionalValue={{ }}
      customClass="top-summary-line"
    />
  );
};

const RevisedCalculator = (props) => {
  return (
    <table style={{ width: '100%' }}>
      <tbody>{props.children}</tbody>
    </table>
  );
};

const TableLabel = ({ firstCaption, secondCaption, rowClass = '' }) => {
  return (
    <tr className={`line-item ${rowClass}`} style={{ color: 'inherit' }}>
      <td className={firstCaption.optionalClass || null }>
        {firstCaption.value}
      </td>
      <td />
      <td className={secondCaption.optionalClass || null }>
        {secondCaption.value}
      </td>
    </tr>
  );
};

export {
  RevisedCalculator,
  TableLabel,
  BorderBottomLineItem,
  BorderTopLineItem
};
